import React from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { MdOutlineCheckCircle, MdOutlineRestore } from "react-icons/md";

const getStatusBadge = (status) => {
  if (String(status) === "1") {
    return (
      <span className="ml-2 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
        Active
      </span>
    );
  }
  if (String(status) === "2") {
    return (
      <span className="ml-2 text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
        Saved
      </span>
    );
  }
  if (String(status) === "0") {
    return (
      <span className="ml-2 text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
        Deleted
      </span>
    );
  }
  return null;
};

const UserBankDetailsList = ({
  bankDetails,
  onSetActive,
  onRestore,
  onDelete,
  isUpdating,
  isRestoring,
  isDeleting,
}) => {
  if (!bankDetails?.length) {
    return (
      <div className="text-sm text-gray-500 border border-dashed border-gray-300 rounded-lg p-4 text-center">
        No bank details found for this user.
      </div>
    );
  }

  return (
    <div className="space-y-3 max-h-64 overflow-y-auto">
      {bankDetails.map((item) => {
        const isDeleted = String(item.status) === "0";
        const isActive = String(item.status) === "1";

        return (
          <div
            key={item.id}
            className={`border rounded-lg p-3 flex justify-between items-start gap-3 ${
              isDeleted
                ? "border-red-200 bg-red-50 opacity-80"
                : "border-gray-200"
            }`}
          >
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-800 capitalize">
                {item.transfer_mode === "upi" ? "UPI" : "Bank Account"}
                {getStatusBadge(item.status)}
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Name:{" "}
                <span className="text-gray-900">
                  {item.bene_name || item?.bene_details?.bene_name || "-"}
                </span>
              </p>
              {item.transfer_mode === "banktransfer" ? (
                <>
                  <p className="text-sm text-gray-600">
                    Bank:{" "}
                    <span className="text-gray-900">{item.bene_bank || "-"}</span>
                  </p>
                  <p className="text-sm text-gray-600">
                    A/C:{" "}
                    <span className="text-gray-900">
                      {item?.bene_details?.bank_account || "-"}
                    </span>
                  </p>
                  <p className="text-sm text-gray-600">
                    IFSC:{" "}
                    <span className="text-gray-900">
                      {item?.bene_details?.ifsc || "-"}
                    </span>
                  </p>
                </>
              ) : (
                <p className="text-sm text-gray-600">
                  UPI ID:{" "}
                  <span className="text-gray-900">
                    {item?.bene_details?.upi_id || "-"}
                  </span>
                </p>
              )}
            </div>

            <div className="flex flex-col gap-2">
              {isDeleted ? (
                <button
                  type="button"
                  title="Restore"
                  disabled={isRestoring}
                  onClick={() => onRestore(item)}
                  className="text-blue-600 hover:text-blue-800 disabled:opacity-50"
                >
                  <MdOutlineRestore className="w-5 h-5" />
                </button>
              ) : (
                <>
                  {!isActive && (
                    <button
                      type="button"
                      title="Set as active"
                      disabled={isUpdating}
                      onClick={() => onSetActive(item)}
                      className="text-green-600 hover:text-green-800 disabled:opacity-50"
                    >
                      <MdOutlineCheckCircle className="w-5 h-5" />
                    </button>
                  )}
                  <button
                    type="button"
                    title="Soft delete"
                    disabled={isDeleting}
                    onClick={() => onDelete(item)}
                    className="text-red-600 hover:text-red-800 disabled:opacity-50"
                  >
                    <AiOutlineDelete className="w-5 h-5" />
                  </button>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserBankDetailsList;
